import { Tooltip } from 'antd';

import { BiInfoCircle } from 'react-icons/bi';

const HelpText = ({ children }) => {
  return (
    <Tooltip title={children} placement="bottom">
      <BiInfoCircle size={20} color="#EC6643" />
    </Tooltip>
  );
};

export default HelpText;
